import { useState, useEffect } from "react";

export const useShowButtons = ({
  childrenCount,
  hasScroll,
  isStart,
  isEnd,
  alwaysShowButtons,
}) => {
  const [mountButtons, setMountButtons] = useState(alwaysShowButtons);
  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(false);

  useEffect(() => {
    const showBoth = alwaysShowButtons || childrenCount > 3 || hasScroll;

    setMountButtons(showBoth);
    setShowPrev(showBoth && !isStart);
    setShowNext(showBoth && !isEnd);
  }, [childrenCount, hasScroll, isStart, isEnd, alwaysShowButtons]);

  return {
    mountButtons,
    showPrev,
    showNext,
    hidePrev: !showPrev,
    hideNext: !showNext,
  };
};
